// extracted by mini-css-extract-plugin
module.exports = {"watermark":"Watermark_watermark__7aOOS"};